module.exports = __webpack_public_path__ + "img/mac-wecom.3e89ff14.png";